import { memo, Dispatch, SetStateAction, ChangeEvent, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Rating,
  Button,
  Typography,
} from "@mui/material";
import Icon from "../../../assets/Images/Icon.png";
import { aiCycleImageRequest } from "Components/MainBody/api";
import { clearLocalStorage } from "Common/common";
import { useNavigate } from "react-router-dom";

interface RattingDialogProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  sessionId?: number;
  isClickOut: boolean;
  setIsClickOut: Dispatch<SetStateAction<boolean>>;
}

function RattingDialog({
  open,
  setOpen,
  sessionId,
  isClickOut,
  setIsClickOut,
}: RattingDialogProps) {
  const [rateNote, setRateNote] = useState<string>("");
  const [ratePoint, setRatePoint] = useState<number | null>(2.5);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const navigate = useNavigate();
  const handleChangeTextArea = (
    e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    setRateNote(e.target.value);
  };

  const handleSubmit = async () => {
    try {
      setIsSubmitting(true);
      await aiCycleImageRequest.post("/valuation/feedback", {
        sessionId,
        ratePoint,
        rateNote,
      });
      if (isClickOut) {
        navigate("/", { replace: true });
        clearLocalStorage();
      }
      setOpen(false);
    } catch (error) {
      console.log(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = (event: object, reason: string) => {
    if (reason !== "backdropClick") {
      setOpen(false);
    }
  };
  return (
    <Dialog open={open} onClose={handleClose}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          paddingTop: "25px",
        }}
      >
        <img src={Icon} alt="" style={{ width: 60, height: 60 }} />
      </div>
      <DialogTitle sx={{ fontSize: 20, textAlign: "center", fontWeight: 600 }}>
        Đánh giá giá trị xe
      </DialogTitle>
      <DialogContent>
        <Rating
          name="half-rating"
          value={ratePoint}
          onChange={(event, newValue) => {
            setRatePoint(newValue);
          }}
          precision={0.5}
          size="large"
          sx={{ fontSize: "80px", display: "flex" }}
        />
        <Typography variant="body1" sx={{ fontWeight: 600, mt: 3 }}>
          Đánh giá
        </Typography>
        <textarea
          style={{ width: "100%", height: 150, marginTop: 15, padding: 15 }}
          placeholder="Viết đánh giá tại đây..."
          onChange={handleChangeTextArea}
        />
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          disabled={isSubmitting}
          fullWidth
          sx={{ backgroundColor: "rgb(87, 104, 255)" }}
          onClick={handleSubmit}
        >
          Gửi
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default memo(RattingDialog);
